import {SearchComponent} from '../search';
import React from 'react';
import {SearchPageType} from '../search-config';
import {useSynchronizeSearchFromUrl} from '../search-hooks';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {useTranslationsRequest} from '../../backendTranslations/backendTranslations-service';

export const SearchPage = React.memo(() => {
    const searchConfig = useSelector((state) => state.config.search);
    const {push} = useHistory();
    if (!searchConfig.enabled) {
        push('/');
    }
    useTranslationsRequest();
    useSynchronizeSearchFromUrl(SearchPageType.BASIC);

    return (
        <SearchComponent
            searchPageType={SearchPageType.BASIC}
        />
    );
});



